
import { browserType } from './util'

const UNASSIGN_COLOR = "#409EFF"
const UNSTART_COLOR = "#409EFF"
const STARTED_COLOR = "#E6A23C"
const END_COLOR = "#67C23A"
const DELAY_COLOR = "red"
const ECHART_COLORS = ['#56A6D1','#75BDE1','#F8D49C','#F8BC9B','#F89B9B','#2ABEC6','#36CFBE','#5EDEAD','#8EEA97']


const OSS_URL=process.env.VUE_APP_OSS_URL;
const MY_URL=process.env.VUE_APP_PAGE_URL;

export default{
    UNASSIGN_COLOR,UNSTART_COLOR,STARTED_COLOR,END_COLOR,DELAY_COLOR,ECHART_COLORS,
    OSS_URL,MY_URL
}


export function logout(){
    var b = browserType();
    if(b==='android'){
      window.GTGoldObject.logOut();
    }else if(b==='ios'){
      window.webkit.messageHandlers.GTGoldObject.postMessage({"method":"logOut"});
    }
}     
export function location(){
    var b = browserType();
    if(b==='android'){
      window.GTGoldObject.location();
    }else if(b==='ios'){
      
      window.webkit.messageHandlers.GTGoldObject.postMessage({"method":"location"});
    }
}

export function checkData(val) {
    
    if (val) {
        return val;
    }
    return "";
}